<template>
  <div>
    <IFRAME width="100%" height="1200px" :src="URL"></IFRAME>
  </div>
</template>
<script>
import { getLudpUrl } from './api'

export default {
  data() {
    return {
      URL: '',
    }
  },
  async mounted() {
    const data = await getLudpUrl()
    this.URL = data
  },
}
</script>
